import React from "react";
import './error.scss';

const Error = (props) => {
    return (
        <p aria-live="polite">
            <span className="material-symbols-outlined">error</span>{props.message}
        </p>
    );
};

Error.defaultProps = {
    message: "Enter a value"
};

export default Error;